import mixpanel from "mixpanel-browser";

import { config } from "@/config";

mixpanel.init(config.mixpanel.token, { host: "api-eu.mixpanel.com" });

export { mixpanel };
